import { render, staticRenderFns } from "./PortfolioIntro.vue?vue&type=template&id=5b66bbb8&"
import script from "./PortfolioIntro.vue?vue&type=script&lang=ts&"
export * from "./PortfolioIntro.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioIntro.vue?vue&type=style&index=0&lang=less&scopped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports